import { isAxiosError } from "axios"

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === `object` && value !== null
}

const getHowToFixFromData = (data: unknown): string | null => {
  if (!isRecord(data)) {
    return null
  }

  const { howToFix } = data
  if (typeof howToFix === `string` && howToFix.trim()) {
    return howToFix
  }

  return null
}

export const parseAxiosError = (
  error: unknown,
  fallback = `Something went wrong`,
): string => {
  if (!isAxiosError(error)) {
    return fallback
  }

  const message = error.response?.data?.message

  if (Array.isArray(message)) {
    return message.join(`, `)
  }

  if (typeof message === `string` && message.trim()) {
    return message
  }

  return error.message || fallback
}

export const getAxiosErrorHowToFix = (error: unknown): string | null => {
  if (!isAxiosError(error)) {
    return null
  }

  return getHowToFixFromData(error.response?.data)
}
